/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 *
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 *
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
 */

/*
* Block compatibility check functions

// --------------- How to use it: ----------------
In the block definitios, call appropriate functions and define the type of connection in setPreviousStatement() statement
this.setPreviousStatement(true, 'type_of_this_block')
this.setNextStatement(true, getAllowedOutputs('type_of_this_block'))
this.appendStatementInput()
    .setCheck(getAllowedStatement('type_of_this_block'))

// -------------- Types of blocks ----------------
    - optical
  - optical_data
  - optical_area_time
  - dem
  - dem_vis
  - other_data
  - other_vis
  - land_cover
  - boundaries
  - dates
    - radar
    - forest_data
    - optical_filter
    - indices
    - pca
    - tca
    - unsup
    - sup
    - band_math_expression
    - band_math_input
    - change_simple
    - hcs
    - timeseries
    - time_series
    - rgb_vis
    - radar_vis
    - forest_vis
  - spectral_graph
  - histogram
  - time_series
  - comparison
*/

// Next Statement
function getAllowedOutputs(type) {

    var array_Options = {  //lots commented out to remove combinations that will break stuff

        'optical_filter': ['indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'timeseries', 'histogram', 'time_series', 'change_simple', 'rgb_vis', 'optical_filter'],

        'optical_area_time': [], //['optical_area_time'],

        'optical_data': [], //['optical_data', 'change_simple', 'dates', 'boundaries'],

        'radar_only': [], //['radar_only'],

        'boundaries': [], //['boundaries', 'dates', 'optical_filter'],

        'dates': [], //['boundaries', 'dates'],

        'dem_vis': ['histogram', 'download'], //['dem_vis', 'histogram'],

        'other_vis': ['histogram', 'presentation', 'download', 'band_selection'], //['other_vis', 'timeseries', 'histogram', 'time_series', 'presentation'],

        'indices': ['other_vis', 'change_simple'], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'timeseries', 'histogram', 'time_series', 'rgb_vis'],

        'pca': [], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'time_series', 'timeseries', 'rgb_vis'],

        'tca': [], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'time_series', 'timeseries', 'rgb_vis'],

        'unsup': ['other_vis'], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'time_series', 'timeseries', 'rgb_vis'],

        'sup': ['other_vis'], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'time_series', 'timeseries', 'rgb_vis'], // histogram

        'band_math_input': ['other_vis', 'unsup', 'sup', 'histogram'], //['optical_filter', 'radar_vis', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'time_series', 'timeseries', 'rgb_vis'],

        'hcs': [], //['band_math_input', 'hcs', 'timeseries', 'radar_vis', 'histogram', 'time_series'],

        'timeseries': [], //['optical_filter', 'indices', 'other_vis', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'time_series', 'timeseries', 'rgb_vis', 'radar_vis'],

        'spectral_graph': [], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'time_series', 'timeseries', 'rgb_vis'],

        'histogram': ['presentation'], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'timeseries', 'histogram', 'time_series', 'other_vis', 'hcs'],

        'time_series': [], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'timeseries', 'histogram', 'time_series', 'rgb_vis', 'other_vis', 'radar_vis', 'hcs'],

        'rgb_vis': ['download', 'histogram', 'optical_stats', 'band_selection'], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'timeseries', 'rgb_vis', 'time_series'],

        'change_simple': ['other_vis'], //['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'timeseries', 'rgb_vis', 'histogram', 'time_series'],

        'radar_vis': ['download', 'histogram', 'band_selection'], //['band_math_input', 'hcs', 'timeseries', 'radar_vis', 'histogram', 'time_series'],

        'forest_vis': ['download'], //['band_math_input', 'forest_vis'],

        'comparison': [], //['comparison', 'other_vis'],

        'presentation': ['download', 'presentation'],

        'sup_class': ['sup_class'],

        'spi': ['other_vis', 'comparison'],

        'glacier': ['other_vis']

    };

    return array_Options[type];
}


// Statement Input
function getAllowedStatements(type) {

    var array_Options = {

        'optical': ['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'timeseries', 'time_series', 'rgb_vis', 'optical_filter'],

        'optical_data': ['optical_area_time', 'boundaries', 'dates', 'change_simple'],

        'radar_only': ['optical_area_time', 'boundaries', 'dates'],

        'optical_area_time': ['optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'timeseries', 'time_series', 'rgb_vis', 'hcs', 'radar_vis'],

        'dem': ['dem_vis', 'histogram'],

        'other_data': ['other_vis', 'histogram', 'timeseries', 'change_simple'],

        'other_data_only': ['boundaries', 'dates'],

        'forest_data': ['other_vis'],

        'hansen_time_series': ['timeseries', 'timeseries_other', 'other_vis'],

        'land_cover': ['other_vis'],

        'biomass': ['other_vis'],

        'fires_droughts': ['other_vis', 'timeseries', 'histogram', 'comparison'],

        'boundaries': ['dates', 'optical_filter', 'change_simple', 'indices', 'hcs', 'radar_vis', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'rgb_vis'],

        'boundaries_other': ['dates', 'change_simple', 'pca', 'tca', 'unsup', 'sup', 'histogram'],

        'dates': ['boundaries', 'optical_filter', 'indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'histogram', 'rgb_vis', 'hcs', 'radar_vis'],

        'dates_other': ['boundaries', 'pca', 'tca', 'unsup', 'sup', 'histogram'],

        'radar': ['band_math_input', 'hcs', 'timeseries', 'radar_vis', 'histogram', 'time_series'],

        'optical_filter': ['indices', 'pca', 'tca', 'unsup', 'sup', 'band_math_input', 'spectral_graph', 'timeseries', 'histogram', 'time_series', 'change_simple', 'rgb_vis', 'optical_filter'],

        'band_math_expression': ['band_math_input'],

        'band_math_input': ['band_math_expression'],

        'scatter_x_input': ['scatter_x_bands', 'scatter_math'],

        'scatter_y_input': ['scatter_y_bands', 'scatter_math', 'graph_indices'],

        'scatter_single_y_input': ['scatter_y_bands'],

        'change_simple': ['indices', 'optical_filter', 'sup', 'band_math_input', 'rgb_vis', 'radar_vis'],

        'timeseries': ['indices', 'rgb_vis', 'radar_vis', 'other_vis', 'hansen_time_series'],

        'timeseries_optical': ['indices', 'rgb_vis'],

        'timeseries_radar': ['radar_vis'],

        'timeseries_other': ['hansen_time_series', 'other_vis'],

        'spectral_graph': ['band_math_expression'],

        'histogram': ['band_math_expression'],

        'time_series': ['band_math_expression'],

        'comparison': ['other_vis'],

        'sup': ['sup_class'],

        'precip_data': ['other_vis', 'spi', 'timeseries'],

        'precip_data_only': ['boundaries', 'dates'],

        'earthquake': ['other_vis'],

        'glacier': ['other_vis'],
    };

    return array_Options[type];
}
export { getAllowedOutputs, getAllowedStatements };
